import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class PrintsRulesService {
  env = environment.env;
  maintenancePrintsRulesURL = endpointsURL.maintenancePrintsRulesURL;

  constructor(private httpClient: HttpClient) {}

  public list(filters?: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenancePrintsRulesURL}lista${filters}`
    );
  }

  public getPrintRule(id: number): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenancePrintsRulesURL}edit?_identificador=${id}`
    );
  }

  public createPrintRule(printRule: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenancePrintsRulesURL}edit`,
      printRule
    );
  }

  public removePrintRule(ids: string[]): Observable<any> {
    let params = new HttpParams();

    ids.forEach((e) => {
      params = params.append("_identificadores", e);
    });
    return this.httpClient.delete<any>(
      `${this.env}${this.maintenancePrintsRulesURL}edit`,
      {
        params: params,
      }
    );
  }
  public updatePrintRule(printRule: any, id: number): Observable<any> {
    return this.httpClient.put<any>(
      `${this.env}${this.maintenancePrintsRulesURL}edit?_identificador=${id}`,
      printRule
    );
  }

  public modeUpDownPrintRule(order: string, id: number): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenancePrintsRulesURL}edit/mover?_identificador=${id}&_orden=${order}`
    );
  }
}
